"use strict";
/**
 * Nome de uma cobrança para mostrar e para o extrato.
 *
 * Mensalidade vira "Mensalidade Outubro/2026"; avulsa usa a descrição que o
 * admin deu ("Racha bola nova"). Um lugar só para API, web, app e WhatsApp
 * escreverem igual.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthLabel = monthLabel;
exports.feeTitle = feeTitle;
/** "2026-10" → "Outubro/2026". */
function monthLabel(reference) {
    const [year, month] = reference.split('-').map(Number);
    // Meia-noite UTC do dia 1 formatada no fuso local (UTC−3) cairia no mês
    // anterior — por isso o timeZone fixo.
    const label = new Intl.DateTimeFormat('pt-BR', { month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(year ?? 2026, (month ?? 1) - 1, 1)));
    return `${label.charAt(0).toUpperCase()}${label.slice(1)}/${year}`;
}
function feeTitle(fee) {
    if (fee.kind === 'EXTRA')
        return fee.description?.trim() || 'Cobrança avulsa';
    return `Mensalidade ${monthLabel(fee.referenceMonth)}`;
}
//# sourceMappingURL=fee.js.map